export const ONE_TIME_PAYMEENT_REASONS = [{ value: 'LAST_DAY_PAY', text: 'Termination' }];

export const isEmailAddressValid = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email) {
    return undefined;
  }
  return emailRegex.test(email);
};
